/**
 * Presentational component for the table body.
 */

import TableValue from './TableValue';
import type { TableColumn } from '../../types/TableColumn';
import type { BestWorstValues } from '../../types/BestWorstValues';
import type { Location } from '../../types/Location';

export default function TableBody({
  data,
  columns,
  location,
  bestValues,
  worstValues,
}: {
  data: object[];
  columns: TableColumn[];
  location?: Location;
  bestValues?: BestWorstValues;
  worstValues?: BestWorstValues;
}): JSX.Element {
  return (
    <tbody className="divide-y divide-gray-200 dark:divide-slate-700 text-xs bg-white dark:bg-[#182235] border-slate-200 dark:border-slate-700">
      {data.map((row, i) => (
        <tr key={i} data-cy={`row-${i}`}>
          {columns.map((col) => {
            const value = row[col.key as keyof typeof row];
            let href = col.href;

            if (href !== undefined) {
              href = href.replace(
                'locationId',
                row['locationId' as keyof object] as string
              );
              href = href.replace(
                'scheduledOpenTime',
                row['scheduledOpenTime' as keyof object] as string
              );
              href = href.replace(
                'scheduledCloseTime',
                row['scheduledCloseTime' as keyof object] as string
              );
            }

            return (
              <TableValue
                key={col.key}
                value={value}
                column={col}
                location={location}
                scheduledOpenTime={row['scheduledOpenTime' as keyof object] as string}
                scheduledCloseTime={row['scheduledCloseTime' as keyof object] as string}
                locationId={row['locationId' as keyof object] as string}
                isBestValue={
                  bestValues !== undefined && bestValues[col.key] === value
                }
                isWorstValue={
                  worstValues !== undefined && worstValues[col.key] === value
                }
                href={href}
              />
            );
          })}
        </tr>
      ))}
    </tbody>
  );
}
